import {
    URLAPI,
    SERVICE_PATH,
    SERVICE_CREATE_PATH,
    SERVICE_UPDATE_PATH
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_service: {
        data: [],

        status: 0,
        message: {},
    },

    _create_service: {
        data: {},
        status: 0,
        message: {},
    },
    _update_service: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_SERVICE = "GET_ALL_SERVICE";
export const CREATE_SERVICE = "CREATE_SERVICE";
export const UPDATE_SERVICE = "UPDATE_SERVICE";

export const service_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_SERVICE:
            return {
                ...state,
                _get_all_service: action.payload,
            };
        case CREATE_SERVICE:
            return {
                ...state,
                _create_service: action.payload,
            };
        case UPDATE_SERVICE:
            return {
                ...state,
                _update_service: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllService = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${SERVICE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_SERVICE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_SERVICE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_SERVICE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const createService = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${SERVICE_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_SERVICE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_SERVICE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_SERVICE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateService = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${SERVICE_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_SERVICE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_SERVICE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_SERVICE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_service = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
